import React from "react";
import classNames from "classnames";
import Styles from "./Modal.module.scss";

const PaymentModal = ({ isOpen, onClose, children, CloseBtn }) => {
  if (!isOpen) return null;

  return (
    <div
      className={classNames(Styles.modal__payment__backdrop)}
      onClick={onClose}
    >
      <div
        className={classNames(Styles.modal__payment__content)}
        onClick={(e) => e.stopPropagation()} // 防止點擊內容區域觸發關閉
      >
        {CloseBtn ? (
          <button
            className={classNames(Styles.modal__payment__close)}
            onClick={onClose}
          >
            ×
          </button>
        ) : null}

        {children}
      </div>
    </div>
  );
};

export default PaymentModal;
